<template>
  <div style="display: flex; flex-direction: column; gap: 10px">
    <div
        v-if="isFiltersOpen"
        style="
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 40px;
          "
    >
      <div>
        <span style="margin-right: 10px">Alarm ID</span>
        <InputText v-model="alarmPointId" placeholder="Filter by Alarm ID"/>
      </div>

      <div>
        <span style="margin-right: 10px">System ID</span>
        <InputText v-model="systemId" placeholder="Filter by System ID"/>
      </div>
    </div>
    <DataTable :value="alarmPoints"
               :paginatorTemplate="'FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink'"
               :paginator="true"
               :page="apCurrentPage"
               :dataKey="tableDataKey"
               :rows="alarmPointRows"
               :scrollable="true"
               :lazy="true"
               :totalRecords="apTotalRecords"
               @page="setApCurrentPage"
               class="tight"
    >
      <Column
          :header="_t('label_alarm_id')"
          :style="'width: 100%' + '%; word-break: break-all; min-height: 38px;'"
          field="alarmPointId"
          header-style="padding-left: 19px!important;"
      >
        <template #body="slotProps">
            <span style="word-break: break-all; padding-left: 5px"
            >
              {{ slotProps.data.alarmPointId }}
            </span>

        </template>
      </Column>
      <Column
          :header="_t('label_system_id')"
          style="width: 100%; word-break: break-all; min-height: 38px;"
          field="systemId"
          header-style="padding-left: 19px!important;"
      >
        <template #body="slotProps">
            <span style="text-align: center; word-break: break-all; padding-left: 5px"
            >
              {{ slotProps.data.systemId }}
            </span>

        </template>
      </Column>
      <template #empty> No alarms found</template>
    </DataTable>
  </div>
</template>

<script>
import { getListExtended } from "@/api/list";
import { debounce } from "lodash";

export default {
  name: "alarm-events",
  props: {
    isFiltersOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      alarmPointId: "",
      systemId: "",
      alarmPoints: [],
      isLoading: false,
      alarmPointRows: 15,
      apCurrentPage: 0,
      apTotalRecords: 0,
      tableDataKey: null,
    };
  },
  computed: {
    alarmPointMultiFilter() {
      return {
        active: "ANY",
        alarmPointId: this.alarmPointId,
        deleted: false,
        hasConfirmation: "ANY",
        hasFollowUp: "ANY",
        hasRepetition: "ANY",
        hasStandbySchedule: "ANY",
        isLifesign: "ANY",
        members: [],
        name: "",
        priority: { high: 10, low: 0 },
        systemId: this.systemId,
        withAlarmPlans: "ANY",
        withAttachments: "ANY",
      };
    },
  },
  created() {
    this.debouncedFilterUpdate = debounce(this.getAlarmEvents, 500);
  },
  mounted() {
    this.getAlarmEvents();
  },
  watch: {
    alarmPointId() {
      this.debouncedFilterUpdate();
    },
    systemId() {
      this.debouncedFilterUpdate();
    },
  },
  methods: {
    getAlarmEvents() {
      this.isLoading = true;
      getListExtended({"alarmPointMultiFilter": this.alarmPointMultiFilter}, 'ALARMPOINT', this.apCurrentPage, this.alarmPointSearch, this.alarmPointRows, this.orgId, true, 'alarmPointId', this.isDeleted, ).then((response) => {
        this.alarmPoints = response.data.list;
        this.apTotalRecords = response.data.count;
        this.isLoading = false;
      });
    },
    setApCurrentPage({ page }) {
      this.apCurrentPage = page;
      this.isLoading = true;
      this.getAlarmEvents();
    },
  },
};
</script>
